import {useEffect, useState} from "react";
import {ChartDataModel, ChartModel} from "../models/ChartDataModel";
import {Localizer} from "../../../infrastructure/localization/localizer";
import {
    GetUddannelsestypeFromIdTranslation,
} from "../../../core/sharedmodels/stilling/uddannelseTypeEnum";
import {DashboardColors} from "../models/DashboardColors";
import {GroupByKeyAndApplyName} from "../dashboardUtils";
import {DashboardPieChartModel} from "../models/DashboardPieChartModel";
import {DashboardForloebModel} from "./DashboardForloebModel";
import {useDashboardContext} from "../dashboardContextProvider";
import {useHistory} from "react-router-dom";
import {removeWhiteSpace} from "../../../core/helpers/stringHelper";
import {InitialFilterModel} from "../../../core/components/reactTable/ReactBaseTable";
import {nameof} from "ts-simple-nameof";
import {DashboardListForloebModel} from "../dashboardList/models/DashboardListForloebModel";
import {RoutePaths} from "../../../infrastructure/routes";

function getFill(chartModel: DashboardPieChartModel<DashboardForloebModel>, index: number) {
    return chartModel.models[0].specialeColor !== "#FFFFFF"
        ? chartModel.models[0].specialeColor
        : DashboardColors.GetSpecialeColor(index, chartModel.name);
}

const useDashboardUddannelsesleager = () => {
    const history = useHistory();
    const [pieChart, setPieChart] = useState<ChartModel[]>([]);
    const {state} = useDashboardContext()

    const dataAmount = state.uddannelseslaeger.length;

    useEffect(() => {
        let pieModels: ChartModel[] = []
        const uddannelseslaeger = state.uddannelseslaeger;
        const uddannelseslaegerGrouped = GroupByKeyAndApplyName(uddannelseslaeger.sort((a, b) => a.uddannelsestype - b.uddannelsestype), x => x.uddannelseId, x => GetUddannelsestypeFromIdTranslation(x.uddannelseId));
        const uddannelseslaegerOnUddannelse = Object.keys(uddannelseslaegerGrouped)
            .map(key => ({
                key: uddannelseslaegerGrouped[key].key,
                name: uddannelseslaegerGrouped[key].name,
                models: uddannelseslaegerGrouped[key].items.sortBy(x => x.specialenavn),
                handleOnClick: () => handleUddannelseCellClick(uddannelseslaegerGrouped[key].name)
            })) as DashboardPieChartModel<DashboardForloebModel>[]

        const uddannelseslaegerOnUddannelsePieChart = mapToPieChartModel(uddannelseslaegerOnUddannelse, Localizer.global_uddannelsestrin())
        pieModels.push(uddannelseslaegerOnUddannelsePieChart)

        const laegerOnSpecialerInUddannelser = uddannelseslaegerOnUddannelse.map(x => {
            return GroupByKeyAndApplyName(x.models, x => x.specialeId, x => `${x.specialenavn}`)
        })

        const uddannelseslaegerOnSpecialer: DashboardPieChartModel<DashboardForloebModel>[] = []
        laegerOnSpecialerInUddannelser.forEach(group => {
            Object.keys(group).forEach(key => {
                const uddannelse = GetUddannelsestypeFromIdTranslation(group[key].items[0].uddannelseId);
                uddannelseslaegerOnSpecialer.push({
                    key: group[key].key + group[key].items[0].uddannelseId,
                    name: group[key].name,
                    models: group[key].items,
                    handleOnClick: () => handleSpecialeCellClick(group[key].name, uddannelse),
                    subName: GetUddannelsestypeFromIdTranslation(group[key].items[0].uddannelseId, true, true, true)
                });
            });
        });
        const uddannelseslaegerOnSpecialerPieChart = mapToPieChartModel(uddannelseslaegerOnSpecialer, Localizer.global_specialer());
        pieModels.push(uddannelseslaegerOnSpecialerPieChart);
        setPieChart(pieModels);

        const handleSpecialeCellClick = (specialenavn: string, uddannelse: string) => {
            history.push({
                pathname: RoutePaths.Dashboard({activeTab: removeWhiteSpace(Localizer.dashboard_listView()) }).url,
                state: [
                    {
                        initialFilterId: nameof<DashboardListForloebModel>(x => x.uddannelsestype),
                        initialFilterValue: uddannelse
                    },
                    {
                        initialFilterId: nameof<DashboardListForloebModel>(x => x.specialeNavn).toLowerCase(),
                        initialFilterValue: specialenavn
                    }
                ] as InitialFilterModel[]
            });
        };

        const handleUddannelseCellClick = (uddannelse: string) => {
            history.push({
                pathname: RoutePaths.Dashboard({activeTab: removeWhiteSpace(Localizer.dashboard_listView()) }).url,
                state: [{
                    initialFilterId: nameof<DashboardListForloebModel>(x => x.uddannelsestype),
                    initialFilterValue: uddannelse
                }] as InitialFilterModel[]
            });
        };
    }, [history, state.uddannelseslaeger]);

    const mapToPieChartModel = (chartModels: DashboardPieChartModel<DashboardForloebModel>[], pieName: string): ChartModel => {
        let elements: ChartDataModel[] = [];
        chartModels.forEach((chartModel, index) => {
                switch (pieName) {
                    case Localizer.global_uddannelsestrin():
                        elements.push(new ChartDataModel(chartModel.key, chartModel.name, chartModel.models.length, DashboardColors.GetUddannelsestrinFillColor(chartModel.models[0].uddannelsestype), chartModel.handleOnClick))
                        break
                    case Localizer.global_specialer():
                        elements.push(new ChartDataModel(chartModel.key, chartModel.name, chartModel.models.length, getFill(chartModel, index), chartModel.handleOnClick,
                            GetUddannelsestypeFromIdTranslation(chartModel.models[0].uddannelseId),
                            DashboardColors.GetUddannelsestrinFillColor(chartModel.models[0].uddannelsestype),
                            chartModel.subName)) //Vi skal have uddannelsestype fra modellen for at kunne angive uddannelsestrin i hoverinfo for specialer
                        break
                    default:
                        break;
                }
            }
        );

        return {
            name: pieName,
            elements: elements
        };
    };

    return {
        pieChart: pieChart,
        isLoading: state.uddannelseslaegerIsLoading,
        dataAmount: dataAmount,
    }
}
export default useDashboardUddannelsesleager;
